module.exports = __webpack_public_path__ + "images/yn11x5.ce1d.png";